/**
 * W3C Trace Context `traceparent` for browser → Vision (and Vision-proxied) hops.
 *
 * Pulse is a CloudFront SPA — it cannot OTLP to Bifrost (VPC-internal). Emitting a
 * client span id here lets Vision's OTel instrumentation continue the same trace so
 * Grafana can join Pulse clicks to server spans / LOG_CONTRACT TraceId columns.
 *
 * Format: `version-traceid-spanid-flags` (version `00`, sampled `01`).
 * Spec: https://www.w3.org/TR/trace-context/
 */

const TRACEPARENT_HEADER = 'traceparent'

export { TRACEPARENT_HEADER }

/** Fresh random traceparent for one outbound fetch. */
export function newTraceparent(): string {
  const bytes = new Uint8Array(24)
  crypto.getRandomValues(bytes)
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('')
  return `00-${hex.slice(0, 32)}-${hex.slice(32, 48)}-01`
}

/** Attach (or replace) `traceparent` on a Headers init. */
export function withTraceparent(headers: Headers): Headers {
  headers.set(TRACEPARENT_HEADER, newTraceparent())
  return headers
}
